var exports = {
  "n": "crossReferencesList__-xQvzF",
};

module.exports = exports;
